import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SpotLiftRecord } from '../lift-by-spot-tile/lift-by-spot-tile.component';
import { Brand } from '../../../../core/models/brand';
import { Subscription } from 'rxjs';
import {DemoConstants} from "../../../../assets/data/demoConstants";

@Component({
  selector: 'lift-by-spot-full',
  templateUrl: './lift-by-spot-full.component.html',
  styleUrls: ['lift-by-spot-full.component.scss']
})
export class LiftBySpotFullComponent implements OnInit, OnDestroy {
  spots: any[];
  loading = false;
  currentDateRange;
  dateRangeSubscription;
  @Input() brand: Brand;
  @Input() averageLift: number;
  @Output() goBack = new EventEmitter();

  subs: Array<Subscription> = [];
  constructor() {}

  ngOnInit() {
    this.loading = false;
    this.spots = DemoConstants.liftBySpotFull
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  getLiftText(lift: number): string {
    if (!isNaN(lift)) {
      return (100 * lift).toFixed(2) + '%';
    } else {
      return 'N/A';
    }
  }

  needsDivider(i) {
    let recordNum = i + 1;
    return recordNum % 3 !== 0;
  }

  lastRecord(i) {
    if (this.spots.length % 3 !== 0) {
      return i === this.spots.length - 1;
    }
    return false;
  }

  getAffiliateText(spot: SpotLiftRecord): string {
    let text = '';
    spot.affiliates.forEach((el, idx) => {
      text += el;
      if (idx !== spot.affiliates.length - 1) {
        text += ', ';
      }
    });
    return text;
  }

  showDashboard() {
    this.goBack.emit();
  }
}
